import { Document, Page, View } from '@react-pdf/renderer';
import useTranslate from 'hooks/useTranslate';
import React from 'react';
import { checkObjHasValues, generateRandomString } from 'utils';
import {
	Education,
	Experience,
	Language,
	PersonalInfo,
	Projects,
	Skills,
	Social,
	Tools,
	Hobbies,
	Certificates,
	Awards,
	About,
} from './Sections';
interface Template1Props {
	resumeData: { [key: string]: any };
	styles: { [key: string]: any };
	isWebView?: boolean;
}

const Template1: React.FC<Template1Props> = ({ resumeData, styles, isWebView = false }) => {
	const {
		profilePicture,
		shortBio,
		experience,
		details,
		project,
		education,
		skills,
		tools,
		language,
		social,
		manageTemplateFields,
		experienceTitle,
		projectTitle,
		educationTitle,
		toolTitle,
		hobbiesTitle,
		langTitle,
		socialTitle,
		skillTitle,
		hobbies,
		awards,
		certification,
		certTitle,
		awardTitle,
	} = resumeData ?? {};

	const {
		details: SHOW_DETAILS,
		experience: SHOW_EXPERIENCE,
		project: SHOW_PROJECT,
		education: SHOW_EDUCATION,
		skills: SHOW_SKILLS,
		tools: SHOW_TOOLS,
		social: SHOW_SOCIAL,
		language: SHOW_LANGUAGE,
		shortBio: SHOW_SHORTBIO,
		awards: SHOW_AWARDS,
		certification: SHOW_CERTIFICATION,
		hobbies: SHOW_HOBBIES,
	} = manageTemplateFields ?? {};

	const randomString = generateRandomString(8);
	const { translate } = useTranslate();

	return (
		<Document style={styles.document}>
			<Page size="A4" style={styles.page} wrap>
				<About data={{ ...details, shortBio, profilePicture }} styles={styles} />
				<View style={styles.pageInfo}>
					<View style={styles.left}>
						<PersonalInfo data={{ ...details, profilePicture }} styles={styles} />
						{(SHOW_EDUCATION || isWebView) &&
							education?.length &&
							checkObjHasValues(education[0]) && (
								<Education
									data={education}
									styles={styles}
									headerTitle={educationTitle}
									randomString={randomString}
								/>
							)}
						{(SHOW_SKILLS || isWebView) && skills?.length && checkObjHasValues(skills[0]) && (
							<Skills data={skills} styles={styles} headerTitle={skillTitle} />
						)}
						{(SHOW_TOOLS || isWebView) && tools?.length && checkObjHasValues(tools[0]) && (
							<Tools data={tools} styles={styles} headerTitle={toolTitle} />
						)}
						{(SHOW_HOBBIES || isWebView) && hobbies?.length && checkObjHasValues(hobbies[0]) && (
							<Hobbies data={hobbies} styles={styles} headerTitle={hobbiesTitle} />
						)}
						{(SHOW_SOCIAL || isWebView) && social?.length && checkObjHasValues(social[0]) && (
							<Social
								data={social}
								styles={styles}
								headerTitle={socialTitle}
								randomString={randomString}
							/>
						)}
						{(SHOW_LANGUAGE || isWebView) && language?.length && checkObjHasValues(language[0]) && (
							<Language data={language} styles={styles} headerTitle={langTitle} />
						)}
					</View>
					<View style={styles.right}>
						{(SHOW_EXPERIENCE || isWebView) &&
							experience?.length &&
							checkObjHasValues(experience[0]) && (
								<Experience
									data={experience}
									styles={styles}
									headerTitle={experienceTitle}
									translate={translate}
								/>
							)}
						{(SHOW_PROJECT || isWebView) && project?.length && checkObjHasValues(project[0]) && (
							<Projects data={project} styles={styles} headerTitle={projectTitle} />
						)}
						{(SHOW_CERTIFICATION || isWebView) &&
							certification?.length &&
							checkObjHasValues(certification[0]) && (
								<Certificates
									data={certification}
									styles={styles}
									headerTitle={certTitle}
									randomString={randomString}
								/>
							)}
						{(SHOW_AWARDS || isWebView) && awards?.length && checkObjHasValues(awards[0]) && (
							<Awards data={awards} styles={styles} headerTitle={awardTitle} />
						)}
					</View>
				</View>
			</Page>
		</Document>
	);
};

export default Template1;
